import React from 'react'
import './Layouts.css'

 

export const NewAbout = () => {
  return (
    <>
      <section id="sec-why  ">
        <div className="container brand-cont">
          <div className="row ">
            <div className="col-lg-6 offset-lg-3">
              <h2 className="text-center Layout-Title">WHY ASIA PART SOUQ</h2>
              <p className="text-center mb-5">
                From its medieval origins to the digital era, learn everything
                there is to know about the ubiquitous lorem ipsum passage.
              </p>
            </div>
          </div>
          <div className="row About-row">
            <div className="col-lg-4">
              <div className="why-div">
                <img src={'images/why1.svg'} />
                <h6 className='About-h6'>Original Products</h6>
                <p>
                 When it comes to vehicle maintenance and repair, the quality of a part is everything. Our Original Products guarantee that you are purchasing parts that are manufactured to the exact specifications and quality standards of the original equipment manufacturer (OEM)
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={'images/why2.svg'} />
                <h6 className='About-h6'>Affordable Rates</h6>
                 <p className='About-p'>
                 Obtaining high-quality, genuine parts shouldn't break the bank. At Asia Part Souq, we leverage our strong relationships with manufacturers and suppliers to secure the best possible pricing.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={'images/why3.svg'} />
                <h6 className='About-h6'>Wide variety</h6>
                <p className='About-p'>
                Our website is designed with you in mind. With intuitive search functionality, detailed product information, and a secure checkout process, finding and buying the right parts has never been easier. We've optimized every step to save you time and provide complete confidence in your purchase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className='d-flex justify-content-center align-items-center'>
        <section id="sec-blog" style={{ marginTop: "-50px" }}>
        <div className="container">
          <h2 className="mb-md-5 Layout-Title NewsTitle">NEWS & EVENTS</h2>
          <div className="row">
            <div className="col-lg-4">
              <div className="blog-div">
                <div className="blog-img">
                  <img src={'images/blog1.png'} />
                  <span className="date">Sep 21, 2022</span>
                </div>
                <h6 className='About-h6'>
                  This latest hybrid electric tactical vehicle may race across
                </h6>
                <p className='About-p'>
                 This latest hybrid electric tactical vehicle may race across vast distances, utilizing a revolutionary powertrain system. By intelligently switching between its electric and combustion engines, the vehicle optimizes for both silent operation in stealth-critical situations and maximum power output for high-speed pursuits, ensuring mission success.
                </p>
                {/* <button className="read-more-btn">Read More</button> */}

              </div>
            </div>
            <div className="col-lg-4">
              <div className="blog-div">
                <div className="blog-img">
                  <img src="images/blog2.png" />
                  <span className="date">Sep 21, 2022</span>
                </div>
                <h6 className='About-h6'>Car production in UK drops to lowest in 66 years</h6>
                <p className='About-p'>
                UK car production has plummeted to a 66-year low, signaling profound challenges for a sector grappling with a trifecta of issues: post-Brexit trade complexities, a persistent shortage of crucial semiconductor components, and the broader economic headwinds impacting consumer spending. This historic drop highlights the fragility of the supply chain and its far-reaching consequences for a vital part of the British economy.
                </p>
                {/* <button className="read-more-btn">Read More</button> */}

              </div>
            </div>
            <div className="col-lg-4">
              <div className="blog-div">
                <div className="blog-img">
                  <img src={'images/blog3.png'} />
                  <span className="date">Sep 21, 2022</span>
                </div>
                <h6 className='About-h6'>
                  Renault Nissan Mitsubishi to spend $23 billion on EVs in next
                  5 years
                </h6>
                <p className='About-p'>
                 Renault, Nissan, and Mitsubishi are uniting with a formidable $23 billion investment in electric vehicles for the next half-decade, a move that positions the alliance to compete directly with global EV leaders. This aggressive push is not just about building new cars; it's about pioneering shared EV technologies and platforms that will power the future of their entire product lineup, from urban cars to light commercial vehicles.
                </p>
                {/* <button className="read-more-btn">Read More</button> */}

              </div>
            </div>
          </div>
        </div>
        </section>
      </div>
    </>
  );
};
